export default {
    color:"Color"
}